import React from "react";

import { FeatureRoute } from "@/permissions/FeatureRoute";
import { ROUTE_FEATURE_MAP } from "@/permissions/routeFeatureMap";

const Guarded = (path: string, element: React.ReactElement) => {
  return <FeatureRoute feature={ROUTE_FEATURE_MAP[path]}>{element}</FeatureRoute>;
};

export default Guarded;
